// extracted by mini-css-extract-plugin
export var actionIcon = "_rs-0";